<template>
    <div class="page_jr flex-col">
        <div class="group_40 flex-row">
            <div class="group_41 flex-col">

                <span class="text_12">人才理念</span>
                <span class="text_13">
          康柏是一个可以让你充分展示才能的舞台，我们重视员工的个人能力提升以及和谐的团队氛围。我们有一支能征善战坚不可摧的康柏集团军，期待有志之士加入我们的队伍，共创辉煌。
        </span>
                <div class="section_5 flex-col justify-between">
                    <div class="block_3_wrapper" >
                        <div class="block_3 flex-col" :style="{ backgroundImage: `url(${joinData.join})` }"></div>
                    </div>
                    <div class="block_4 flex-row">
                        <div class="box_37 flex-col justify-between">
                            <div class="image-text_73 flex-col justify-between">
                                <div class="image-wrapper_1 flex-col">
                                    <img
                                            class="image_2"
                                            referrerpolicy="no-referrer"
                                            src="../../../assets/contact/contact_01.png"
                                    />
                                </div>
                                <span class="text-group_2">选拔</span>
                            </div>
                            <span class="paragraph_2">
                举贤任能&nbsp;德才兼备&nbsp;
                <br />
                适岗为要&nbsp;多元包容
              </span>
                        </div>
                        <img
                                class="image_3"
                                referrerpolicy="no-referrer"
                                src="../../../assets/contact/contact_line_01.png"
                        />
                        <div class="image-text_74 flex-col justify-between">
                            <div class="image-wrapper_1 flex-col">
                                <img
                                        class="image_2"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/contact/contact_02.png"
                                />
                            </div>
                            <div class="text-group_109 flex-col justify-between">
                                <span class="text_14">使用</span>
                                <span class="paragraph_2">
                  人尽其才&nbsp;才尽其用&nbsp;
                  <br />
                  动态调配&nbsp;绩优则上
                </span>
                            </div>
                        </div>
                        <img
                                class="image_4"
                                referrerpolicy="no-referrer"
                                src="../../../assets/contact/contact_line_01.png"
                        />
                        <div class="image-text_75 flex-col justify-between">
                            <div class="image-wrapper_1 flex-col">
                                <img
                                        class="image_2"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/contact/contact_03.png"
                                />
                            </div>
                            <div class="text-group_110 flex-col justify-between">
                                <span class="text_15">培养</span>
                                <span class="paragraph_2">
                  因材施教&nbsp;挖掘潜力&nbsp;
                  <br />
                  创新赋能&nbsp;终身成长
                </span>
                            </div>
                        </div>
                        <img
                                class="image_5"
                                referrerpolicy="no-referrer"
                                src="../../../assets/contact/contact_line_01.png"
                        />
                        <div class="image-text_76 flex-col justify-between">
                            <div class="image-wrapper_1 flex-col">
                                <img
                                        class="image_2"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/contact/contact_04.png"
                                />
                            </div>
                            <div class="text-group_111 flex-col justify-between">
                                <span class="text_16">激励</span>
                                <span class="paragraph_2">
                  意愿开发&nbsp;目标导向&nbsp;
                  <br />
                  长效激励&nbsp;实现双赢
                </span>
                            </div>
                        </div>
                        <img
                                class="image_6"
                                referrerpolicy="no-referrer"
                                src="../../../assets/contact/contact_line_01.png"
                        />
                        <div class="image-text_77 flex-col justify-between">
                            <div class="image-wrapper_1 flex-col">
                                <img
                                        class="image_2"
                                        referrerpolicy="no-referrer"
                                        src="../../../assets/contact/contact_05.png"
                                />
                            </div>
                            <div class="text-group_112 flex-col justify-between">
                                <span class="text_17">保留</span>
                                <span class="paragraph_2">
                  文化引领&nbsp;氛围影响&nbsp;
                  <br />
                  情感共鸣&nbsp;价值共创
                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block_15 flex-col justify-between">
                    <div class="group_1 flex-row justify-between">
                        <div class="image-wrapper_6 flex-col" :style="{ backgroundImage: `url(${joinData.team})` }"></div>
                        <div class="text-group_113 flex-col justify-between">
                            <span class="text_18">团队建设</span>
                            <span class="paragraph_6">
                在康柏，团队建设一直是企业发展的核心基石
                <br />
                <br />
                我们会为员工提供多样化的学习机会和资源，提供各种培训支持，致力于全面挖掘员工个人综合素质的潜能；
                <br />
                <br />
                我们有成熟的绩效文化和人才发展晋升通道，为员工提供一个挑战与机遇并存的职业环境；
                <br />
                <br />
                我们有多样化的文化活动，为员工营造舒适和谐的氛围，为员工间建立良好的沟通了解基础。
              </span>
                        </div>
                    </div>
                    <div class="group_2 flex-row justify-between">
                        <div class="group_3 flex-col" :style="{ backgroundImage: `url(${joinData.staff})` }"></div>
                        <div class="text-group_114 flex-col justify-between">
                            <span class="text_18">员工关怀</span>
                            <div class="paragraph_6">
                <span class="paragraph_7">
                  在康柏，员工关怀一直是企业秉持的重要理念
                  <br />
                  <br />
                  我们会为员工提供健康舒适的办公环境，配备良好设施；
                  <br />
                  <br />
                  我们会为员工提供具有竞争力的薪酬待遇，提供
                </span>
                                <span class="text_20">弹性工作制度、带薪休假等福利</span>
                                <span class="paragraph_8">
                  ；
                  <br />
                  <br />
                  除国家规定的基本福利以外，我们还提供多项其他福利，例如
                </span>
                                <span class="text_21">节日福利、福利假期、福利体检、员工旅游</span>
                                <span class="text_22">等。</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section_7 flex-row">
                    <img
                            class="image_17"
                            referrerpolicy="no-referrer"
                            src="../../../assets/contact/contact_link.png"
                    />
                    <div class="text-group_115 flex-col justify-between">
                        <span class="text_23">期待您的加入</span>
                        <div class="text-wrapper_5">
                            <span class="text_24">请将个人简历发</span>
                            <span class="text_25">至</span>
                            <span class="text_26">zhaopin&#64;bjchpc.com</span>
                            <span class="text_27">&nbsp;&nbsp;或在boss直聘上搜索康柏汉森查询相应职位。</span>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            joinData: {
                type: Object,
                required: true,
                /*
                default: () => ({
                    "join": require('@/assets/contact/contact_address_bj.png'),
                    "team": require('@/assets/contact/contact_join_02.png'),
                    "staff":require('@/assets/contact/contact_join_03.png'),
                })*/
            }
        },
        data() {
            return {
                constants: {}
            };
        },
        methods: {}
    };
</script>
<style scoped lang="css"  >
    .page_jr {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 1468px;
        overflow: hidden;
    }

    .group_40 {
        width: 1468px;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .group_41 {
        width: 1468px;
    }

    .text_12 {
        width: 136px;
        height: 48px;
        overflow-wrap: break-word;
        color: rgba(29, 29, 31, 1);
        font-size: 34px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 48px;
        margin: 30px 0 0 139px;
    }

    .text_13 {
        width: 1193px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 18px;
        text-align: left;
        line-height: 25px;
        margin: 19px 0 0 138px;
    }

    .section_5 {
        box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
        width: 1202px;
        height: 526px;
        margin: 30px 0 0 133px;
    }
    .block_3_wrapper {
        max-width: 1200px;
        height: 286px;
        overflow: hidden;
        margin-left: 1px;
    }
    .block_3 {
        width: 100%;
        height: 100%;
        background-size: cover;       /* 确保背景图覆盖整个区域 */
        transition: transform 0.3s ease; /* 添加过渡动画 */
    }
    .block_3_wrapper:hover .block_3 {
        transform: scale(1.2);
    }

    .block_4 {
        width: 1201px;
        height: 240px;
        background: url(../../../assets/contact/contact_join_bj_01.png) -30px -30px no-repeat;
        background-size: 1261px 300px;
    }

    .box_37 {
        width: 161px;
        height: 158px;
        margin: 35px 0 0 26px;
    }

    .image-text_73 {
        width: 56px;
        height: 93px;
    }

    .image-wrapper_1 {
        height: 50px;
        background-size: 113px 110px;
        width: 53px;
    }

    .image_2 {
        width: 51px;
        height: 45px;
    }

    .text-group_2 {
        width: 56px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
        margin-top: 3px;
    }

    .image_3 {
        width: 1px;
        height: 200px;
        margin: 20px 0 0 57px;
    }
    .image_3,.image_4,.image_5,.image_6 {
        background: #e5e5e5;
    }

    .image-text_74 {
        width: 156px;
        height: 158px;
        margin: 35px 0 0 26px;
    }


    .text-group_109 {
        width: 156px;
        height: 105px;
        margin-top: 3px;
    }

    .text_14 {
        width: 56px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
        margin-left: 1px;
    }

    .paragraph_2 {
        width: 156px;
        height: 50px;
        overflow-wrap: break-word;
        color: rgba(29, 29, 31, 1);
        font-size: 18px;
        text-align: left;
        line-height: 25px;
        margin-top: 15px;
        transition: color 0.3s ease;
    }
    .paragraph_2:hover {
        color: #008683;
    }

    .image_4 {
        width: 1px;
        height: 200px;
        margin: 20px 0 0 57px;
    }

    .image-text_75 {
        width: 156px;
        height: 158px;
        margin: 35px 0 0 26px;
    }


    .text-group_110 {
        width: 156px;
        height: 105px;
        margin-top: 3px;
    }

    .text_15 {
        width: 56px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
        margin-left: 1px;
    }


    .image_5 {
        width: 1px;
        height: 200px;
        margin: 20px 0 0 58px;
    }

    .image-text_76 {
        width: 156px;
        height: 158px;
        margin: 35px 0 0 26px;
    }


    .label_3 {
        width: 37px;
        height: 35px;
        margin: 6px 0 0 4px;
    }

    .text-group_111 {
        width: 156px;
        height: 105px;
        margin-top: 3px;
    }

    .text_16 {
        width: 56px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }


    .image_6 {
        width: 1px;
        height: 200px;
        margin: 20px 0 0 57px;
    }

    .image-text_77 {
        width: 157px;
        height: 158px;
        margin: 35px 57px 0 26px;
    }


    .text-group_112 {
        width: 156px;
        height: 105px;
        margin: 3px 0 0 1px;
    }

    .text_17 {
        width: 56px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 40px;
    }


    .block_15 {
        width: 1468px;
        height: 892px;
        margin-top: 38px;
    }

    .group_1 {
        width: 1468px;
        height: 446px;
        background: url(../../../assets/contact/contact_bj_03.png) 100% no-repeat;
        background-size: 100% 100%;
    }

    .image-wrapper_6 {
        /* background-image: url(../../../assets/contact/contact_join_02.png);*/
        width: 405px;
        height: 288px;
        cursor: pointer;
        margin: 79px 0 0 134px;
        position: relative;
        overflow: hidden;
        background-image: none;
    }
    .image-wrapper_6::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        transition: transform 0.3s ease;
    }

    .image-wrapper_6:hover::after {
        transform: scale(1.2);
    }


    .text-group_113 {
        width: 736px;
        height: 289px;
        margin: 72px 134px 0 0;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }
    .flex-col {
         display: flex;
         flex-direction: column;
     }

    .text_18 {
        width: 136px;
        height: 48px;
        overflow-wrap: break-word;
        color: rgba(29, 29, 31, 1);
        font-size: 34px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 48px;
    }

    .paragraph_6 {
        width: 735px;
        height: 225px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 25px;
        margin: 16px 0 0 1px;
    }

    .group_2 {
        width: 1468px;
        height: 446px;
        background: url(../../../assets/contact/contact_bj_03.png) 100% no-repeat;
        background-size: 100% 100%;
    }

    .group_3 {
        position: relative;
        overflow: hidden;
        width: 405px;
        height: 288px;
        margin: 73px 0 0 134px;
        cursor: pointer;
        background-image: none;
    }
    /* 添加伪元素承载背景 */
    .group_3::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        transition: transform 0.3s ease; /* 添加过渡动画 */
    }
    /* 悬停时放大效果 */
    .group_3:hover::after {
        transform: scale(1.2);
    }

    .text-group_114 {
        width: 736px;
        height: 294px;
        margin: 72px 134px 0 0;
    }


    .paragraph_7 {
        width: 735px;
        height: 225px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 25px;
    }

    .text_20 {
        width: 735px;
        height: 225px;
        overflow-wrap: break-word;
        color: rgba(37, 144, 138, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 25px;
    }

    .paragraph_8 {
        width: 735px;
        height: 225px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 25px;
    }

    .text_21 {
        width: 735px;
        height: 225px;
        overflow-wrap: break-word;
        color: rgba(36, 144, 137, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 25px;
    }

    .text_22 {
        width: 735px;
        height: 225px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 25px;
    }

    .section_7 {
        width: 1201px;
        height: 148px;
        background: url(../../../assets/contact/contact_bj_02.png)
        100% no-repeat;
        background-size: 100% 100%;
        margin-left: 134px;
        margin-bottom: 30px;
    }

    .image_17 {
        width: 101px;
        height: 148px;
    }

    .text-group_115 {
        width: 850px;
        height: 77px;
        margin: 35px 223px 0 27px;
    }

    .text_23 {
        width: 144px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(29, 29, 31, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
    }

    .text-wrapper_5 {
        width: 850px;
        height: 30px;
        overflow-wrap: break-word;
        font-size: 0;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
        margin-top: 14px;
    }

    .text_24 {
        width: 850px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 22px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
    }

    .text_25 {
        width: 850px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(103, 102, 101, 1);
        font-size: 22px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
    }

    .text_26 {
        width: 850px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(26, 128, 125, 1);
        font-size: 22px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
    }

    .text_27 {
        width: 850px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 22px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 30px;
    }


</style>
